import { requestYfd } from './request'
import { apiHost } from '@/service/request'
import Json2excel from 'custom-json2excel'

export const getCookie = function(key) {
  const list = document.cookie.match(
    new RegExp('(?:^| )' + encodeURIComponent(key) + '=([^;]+)'),
  )
  return list && decodeURIComponent(list[1])
}

export function validateUserStage(srId) {
  return requestYfd(
    `/ep-garden-user-feedback/api/training/feedback/${srId}/validate_user_stage`,
  )
}

export function getTrainingSubsidyInfo(srId) {
  return requestYfd(
    `/ep-garden-user-feedback/api/training/feedback/${srId}/training_subsidy_info`,
  )
}

export function updateTrainingSubsidyInfo(
  srId,
  { candidateId, idCardNo, bankName, bankProvince, bankCardNo },
) {
  return requestYfd(
    `/ep-garden-user-feedback/api/training/feedback/${srId}/training_subsidy_info?candidateId=${candidateId}&idCardNo=${idCardNo}&bankName=${bankName}&bankProvince=${bankProvince}&bankCardNo=${bankCardNo}`,
    {
      method: 'post',
    },
  )
}

export function getcandidateBasicInfo(srId) {
  return requestYfd(`/ep-garden-user-feedback/api/training/feedback/${srId}`)
}

export function download(url, fileName, needEncode) {
  let encodeUri = needEncode ? encodeURI(url) : url
  const a = document.createElement('a')
  a.href = encodeUri
  if (fileName) {
    a.download = fileName
  }
  a.style.display = 'none'
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}
export function downloadFECSV(data) {
  const csvArr = data.map(row => row.join(','))
  const csvStr = csvArr.join('\n')
  const url = `data:attachment/csv,${csvStr}`
  download(url, '失败数据.csv')
}

export function downloadFEExcel(data, fileName) {
  const json2excel = new Json2excel({ data, name: fileName })
  json2excel.generate()
}
export function downloadFromServer(url, fileName) {
  download(`${window.location.protocol}//${apiHost}${url}`, fileName)
}

export function copyData(content) {
  const input = document.createElement('input')
  document.body.appendChild(input)
  input.setAttribute('value', content)
  input.select()
  if (document.execCommand('copy')) {
    document.execCommand('copy')
  }
  document.body.removeChild(input)
}

export function setDawn(data) {
  return data
    .hour(0)
    .minute(0)
    .second(0)
    .millisecond(0)
}
